module.exports = __webpack_public_path__ + "img/e-10.6c8119e2.jpg";